// Colors
export const NOTES_COLORS = {
  TEXT: '#14151C',
  EMPTY_STATE: '#4D5165'
};

// Styles that can't be represented with Tailwind classes
export const SCROLL_CONTAINER_STYLES = {
  maxHeight: 'calc(100vh - 421px)',
  overflowY: 'auto' as const,
  clipPath: 'inset(0 round 8px)'
};

// Only color and custom padding need to be inline styles
export const NOTES_CONTENT_INLINE_STYLES = {
  color: NOTES_COLORS.TEXT,
  paddingBottom: '48px'
};

export const EMPTY_STATE_INLINE_STYLES = {
  color: NOTES_COLORS.EMPTY_STATE,
  paddingBottom: '48px'
};
